import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries } from 'config/config'; // Importing configuration and countries data from config

/**
 * Class representing a view for table type documents.
 * @extends JetView
 */
export default class tableTypeDocumentView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable borders
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Conditional vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Set height based on screen width
            height: screen.width < 820 ? 410 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the edit icon
                    tooltip: _('Editar'),
                    // Template function to render the edit icon based on permissions
                    template: function (obj) {
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingTypeDocumentEdit', 'Edit')) {
                            // Return edit icon if permission is granted
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            // Return empty string if permission is denied
                            return '';
                        }
                    },
                },
                // Column for displaying the ID
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for displaying the reference
                {
                    id: 'Reference',
                    header: 'Referencia',
                    width: 100,
                    sort: 'int',
                },
                // Column for displaying the name with localization
                { id: 'Name', header: _('Nombre'), width: 150, sort: 'int' },
                // Column for displaying the country, conditionally hidden based on permissions
                {
                    id: 'country',
                    header: _('País'),
                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry',
                    width: 150,
                    sort: 'int',
                },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Trigger the 'openEdit' event when the edit icon is clicked
                    vthis.app.callEvent('openEdit', [{}]);
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // API URL for fetching data
            url: devConfig.geturlApi() + 'Accounting/GetTypeDocument',
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service for translations
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Create a modal window for editing document types
        var popup = webix.ui({
            view: 'window',
            id: 'EditCenter',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window title
                    { view: 'label', label: _('Editar tipo de documento') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the window when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            // Center the window on the screen
            position: 'center',
            // Make the window modal
            modal: true,
            body: {
                view: 'form',
                id: 'editForm',
                elements: [
                    {
                        view: 'text',
                        label: 'ID',
                        name: 'Id',
                        // Make the ID field read-only
                        readonly: true,
                        labelWidth: 100,
                    },
                    {
                        view: 'text',
                        label: _('Referencia'),
                        name: 'Reference',
                        labelWidth: 100,
                    },
                    {
                        view: 'text',
                        label: _('Nombre'),
                        name: 'Name',
                        labelWidth: 100,
                    },
                    {
                        view: 'combo',
                        label: _('País'),
                        name: 'Country',
                        // Options for the country selection
                        options: countries,
                        labelWidth: 140,
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                // Cancel button functionality
                                click: function () {
                                    this.getTopParentView().hide();
                                    // Reset the form values to clean state
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                // Save button functionality
                                click: function ($e) {
                                    // Get values from the form
                                    var values =$$('editForm').getValues();
                                    // Send an AJAX POST request to save the document type
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/TypeDocument',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Reference":"' +
                                                values.Reference +
                                                '" ,"Country":"' +
                                                values.Country +
                                                '"}',
                                            {
                                                // Handle error response
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! '));
                                                },
                                                // Handle success response
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Tipo de documento actualizado'));
                                                    // Clear the grid data
                                                    grid.clearAll();
                                                    // Reload the grid with updated data
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                                },
                                            },
                                        );
                                    // Reset the form values to clean state
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                    // Close the window after saving
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
       $$('editForm').bind($$('datatable')); // Binds the edit form to the data table for data synchronization.
        var popupAdd = webix.ui({
            // Creates a new Webix UI window for adding a document type.
            view: 'window',
            id: 'AddCenter', // Unique identifier for the window.
            head: {
                // Header section of the window.
                view: 'toolbar',
                cols: [
                    // Columns in the toolbar.
                    { view: 'label', label: _('Añadir tipo de documento') }, // Label for the window title.
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Icon for closing the window.
                        click: function () {
                            // Click event to hide the window.
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Position the window in the center of the screen.
            modal: true, // Makes the window modal, preventing interaction with other UI elements.
            body: {
                // Body section of the window containing the form.
                view: 'form',
                id: 'addform', // Unique identifier for the form.
                elements: [
                    // Form elements.
                    {
                        view: 'text',
                        label: _('Referencia'), // Label for the reference input.
                        name: 'Reference', // Name of the input field.
                        required: true, // Marks the field as required.
                        labelWidth: 100, // Width of the label.
                    },
                    {
                        view: 'text',
                        label: _('Nombre'), // Label for the name input.
                        name: 'Name', // Name of the input field.
                        required: true, // Marks the field as required.
                        labelWidth: 100, // Width of the label.
                    },
                    {
                        view: 'combo',
                        label: _('País'), // Label for the country selection.
                        name: 'Country', // Name of the input field.
                        options: countries, // Options for the combo box, sourced from the countries variable.
                        required: true, // Marks the field as required.
                        labelWidth: 100, // Width of the label.
                    },
                    {
                        cols: [
                            // Columns for the buttons.
                            {
                                view: 'button',
                                value: _('Cancelar'), // Label for the cancel button.
                                click: function () {
                                    // Click event to hide the window and reset the form.
                                    this.getTopParentView().hide();
                                    $$('addform').setValues(
                                        $$('addform').getCleanValues(), // Resets the form values to clean state.
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Specifies that this button submits the form.
                                value: _('Guardar'), // Label for the save button.
                                click: function ($e) {
                                    // Click event to handle form submission.
                                    var values = $$('addform').getValues(); // Retrieves the form values.
                                    if ($$('addform').validate()) {
                                        // Validates the form.
                                        webix
                                            .ajax() // Initiates an AJAX request.
                                            .headers({
                                                'Content-type': 'application/json', // Sets the content type for the request.
                                            })
                                            .post(
                                                devConfig.geturlApi() + // API endpoint for saving the document type.
                                                    'Accounting/SaveTypeDocument',
                                                '{"Reference":"' +
                                                    values.Reference +
                                                    '", "Name":"' +
                                                    values.Name +
                                                    '", "Country":"' +
                                                    values.Country +
                                                    '"}', // JSON string of the form data.
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error callback for the AJAX request.
                                                        webix.message(
                                                            _('Error! '), // Displays an error message.
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success callback for the AJAX request.
                                                        webix.message(
                                                            _(
                                                                'Tipo de documento agregado', // Displays a success message.
                                                            ),
                                                        );
                                                        grid.clearAll(); // Clears the data in the grid.
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reloads the grid data.
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Resets the form values to clean state.
                                        );
                                        this.getTopParentView().hide(); // Hides the window after submission.
                                    } else {
                                        webix.message({
                                            // Displays an alert if validation fails.
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'), // Message prompting user to complete fields.
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    // Configuration for form elements.
                    on: {
                        onChange: function () {
                            // Event triggered on element change.
                            this.validate(); // Validates the form on change.
                        },
                    },
                },
            },
        });
        // Listen for the 'typeDocument:filter' event on the application instance
        this.on(this.app, 'typeDocument:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty string to build the query parameters

            // Iterate over each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' filter
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split the date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle 'ModifiedLocalDate' filter
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split the date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            // Add other filters to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate over each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date in the nested object
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object
                                    // Format the date to a specific string format
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date to query
                                } else {
                                    // Handle 'end' date in the nested object
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object
                                        // Format the date to a specific string format
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters and pagination
            grid.load(
                url + // Base URL for loading data
                    '?start=0&count=' + // Pagination parameters
                    grid.data.$pagesize + // Current page size from grid data
                    filter + // Additional filter parameters
                    '&sort[' + // Sort parameters
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending or descending)
            );
        });

        // Listen for the 'addTypeDocument:button' event from the app
        this.on(this.app, 'addTypeDocument:button', (filter) => {
            $$('addform').clearValidation(); // Clear any validation errors in the add form
            popupAdd.show(); // Show the popup for adding a new document
        });

        // Listen for the 'openEdit' event from the app
        this.on(this.app, 'openEdit', (filterData) => {
            popup.show(); // Show the popup for editing an existing document
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
